import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { ROUTES_PATH } from 'app/constants/Routes';
import { PlanExplorationModal } from 'app/pages/PlanAndPayment/PlanExplorationModal';
import { useExplorePlansEligibility } from 'app/pages/PlanAndPayment/PlanUpgradeModal/useExplorePlansEligibility';
import { rootReducer } from 'redux/rootReducer';

import type { PlanExplorationOrigin } from './types';

type RootState = ReturnType<typeof rootReducer>;

export const usePlanExploration = () => {
  const history = useHistory();
  const isEligibleForExplorePlans = useExplorePlansEligibility();
  const user = useSelector((state: RootState) => state.auth.user);
  const subscriptionStatus = useSelector(
    (state: RootState) => state.subscription.subscription_status,
  );
  const [isOpen, setIsOpen] = useState(false);
  const [origin, setOrigin] = useState<PlanExplorationOrigin>();

  const openPlanExploration = (openOrigin: PlanExplorationOrigin) => {
    if (!isEligibleForExplorePlans) {
      history.push(ROUTES_PATH.CONFIGURACOES.PLAN_AND_PAYMENT);
      return;
    }

    setOrigin(openOrigin);
    setIsOpen(true);
  };

  const planExplorationModal = (
    <PlanExplorationModal
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      user={user}
      subscriptionStatus={subscriptionStatus}
      url={window.location.pathname.split('/')[1]}
      origin={origin}
    />
  );

  return { openPlanExploration, planExplorationModal, isPlanExplorationOpen: isOpen };
};

export default usePlanExploration;
